import { useQuery } from "@tanstack/react-query";
import axios from "axios";
import Api from "../Api/Api.json";

const fetchNutritionSummaryData = async (patientId) => {
  const headers = { headers: { "Content-Type": "application/json" } };
  const url = Api.FITNESS_API;
  const requestData = {
    task: "getNutritionTimeseriesSummary",
    patient_id: patientId,
  };
  
  const response = await axios.post(url, requestData, headers);
  
  if (!response.data) {
    throw new Error("Network response was not ok");
  }
  
  return response.data;
};

export const getLocalDateKey = (date = new Date()) => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
};

export const getTodayTotalCalories = (nutritionSummaryData) => {
  if (!nutritionSummaryData?.total_calories) {
    return null;
  }

  const todayKey = getLocalDateKey();
  const timeSpans = ["week", "month"];

  for (const span of timeSpans) {
    const timeSpanData = nutritionSummaryData.total_calories[span] || [];
    for (const item of timeSpanData) {
      const dateKey = Object.keys(item)[0];
      if (dateKey === todayKey) {
        const dataObj = item[dateKey];
        const value = dataObj?.total ?? dataObj?.avg ?? null;
        if (value != null && !Number.isNaN(Number(value))) {
          return Math.round(Number(value));
        }
      }
    }
  }

  return null;
};

export const useNutritionSummaryData = (patientId) => {
  // Use React Query to fetch and cache data
  return useQuery({
    queryKey: ["nutritionSummaryData", patientId], // Unique key for this query
    queryFn: () => fetchNutritionSummaryData(patientId), // Function to fetch data
    staleTime: 1000 * 60 * 60, // Data is considered fresh for 1 hour
    cacheTime: 1000 * 60 * 60, // Cache data for 1 hour
    enabled: !!patientId, // Only run query if patientId is provided
  });
};
